// Module
var code = `<div id="jsoneditor"></div>
`;
// Exports
export default code;